// Import the functions you need from the SDKs you need
import { getAnalytics } from "firebase/analytics";
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import "firebase/firestore";
import { getFirestore } from "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBMl9Ahvwu0nBptFST5IHA-pU18AlClIgE",
  authDomain: "gridword-1b6b9.firebaseapp.com",
  projectId: "gridword-1b6b9",
  storageBucket: "gridword-1b6b9.appspot.com",
  messagingSenderId: "978913701516",
  appId: "1:978913701516:web:0cf7eee66f216bb80215a9",
  measurementId: "G-0JTQCLZQHT",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default app;
export const analytics = getAnalytics(app);
export const db = getFirestore(app);
export const auth = getAuth(app);
